import { getStoredData, get_auth_key, storeData } from '../../util';
const { createSlice } = require('@reduxjs/toolkit');

export const permission = createSlice({
  name: 'permission',
  initialState: {
    permissions: []
  },
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    }
  },
});

export const { setPermissions } = permission.actions;
export default permission.reducer;
